export default __webpack_public_path__ + "ba4481d5d02a2f1d22f49235f13fd886.png";